import { Dropdown } from "@mui/base/Dropdown";
import { Menu } from "@mui/base/Menu";
import { MenuButton as BaseMenuButton } from "@mui/base/MenuButton";
import { MenuItem as BaseMenuItem } from "@mui/base/MenuItem";
import { styled } from "@mui/system";
import { Box, Stack, Typography } from "@mui/material";
import { ElementType, useState } from "react";
import { ReactComponent as DownArrowIcon } from "../../assets/down-arrow.svg";

export const DropdownMUI = ({
  items,
  selected,
  onChange,
  Icon,
}: {
  items: string[];
  selected: string | undefined;
  Icon: ElementType;
  RightIcon?: ElementType;
  onChange: (value: string) => void;
}) => {
  const [open, setOpen] = useState(false);

  return (
    <Dropdown open={open} onOpenChange={() => setOpen(!open)}>
      <MenuButton>
        <Box
          display="flex"
          alignItems={"center"}
          justifyContent={"space-between"}
          gap={2}
          width={300}
          height={20}
          p={2}
        >
          <Stack flexDirection={"row"} gap={1} alignItems={"center"}>
            <Icon />
            <Typography
              fontSize={16}
              fontWeight={"bold"}
              fontFamily={"sans-serif"}
            >
              {selected}
            </Typography>
          </Stack>
          <Box
            component="span"
            sx={{
              display: "flex",
              transition: "transform 0.3s ease",
              transform: open ? "rotate(180deg)" : "rotate(0deg)", 
            }}
          >
            <DownArrowIcon />
          </Box>
        </Box>
      </MenuButton>
      <Menu slots={{ listbox: Listbox }}>
        {items.map((menuItem, index) => (
          <MenuItem key={index} onClick={() => onChange(menuItem)}>
            {menuItem}
          </MenuItem>
        ))}
      </Menu>
    </Dropdown>
  );
};

const grey = {
  50: "#F3F6F9",
  100: "#E5EAF2",
  200: "#DAE2ED",
  300: "#C7D0DD",
  400: "#B0B8C4",
  500: "#9DA8B7",
  600: "#6B7A90",
  700: "#434D5B",
  800: "#303740",
  900: "#1C2025",
};

const Listbox = styled("ul")(
  ({ theme }) => `
    background-color: #F3F6F9;    
      width: 345px;
      display: flex;
      align-items: center;
      transition: all 150ms ease;
      justify-content: center;
      flex-direction: column;
      margin: 0;
      margin-top: 8px;
      padding: 0;
      .closed & {
          opacity: 0;
          transform: scale(0.95, 0.8);
          transition: opacity 200ms ease-in, transform 200ms ease-in;
        }
        
      .open & {
          opacity: 1;
          transform: scale(1, 1);
          transition: opacity 100ms ease-out, transform 100ms cubic-bezier(0.43, 0.29, 0.37, 1.48);
        }

      .placement-top & {
          transform-origin: bottom;
        }

      .placement-bottom & {
          transform-origin: top;
        }
    `
);

const MenuItem = styled(BaseMenuItem)(
  ({ theme }) => `
    list-style: none;
    padding: 8px;
    background-color: #F3F6F9;
    min-width: 100%;
    border-bottom: 1px solid ${grey[200]};
    transition: all 150ms ease;
    cursor: default;
    user-select: none;
    &:last-of-type {
      border-bottom: none;
    }
  
    &:focus {
      outline: 1px solid #ffd200;
      background-color: #ffd200;
      color: #000;
    }
  
    &:hover {
      background-color: #ffd200;
      color: #000;
    }
  
    `
);

const MenuButton = styled(BaseMenuButton)(
  ({ theme }) => `
    font-family: 'IBM Plex Sans', sans-serif;
    font-weight: 600;
    font-size: 0.875rem;
    line-height: 1.5;
    padding: 8px 16px;
    transition: all 150ms ease;
    cursor: pointer;
    background: #FFD200;
    border: 0px solid #FFD200 !important;
    color: #000;
  
    &:hover {
      background:  #FFD200;
      border-color:  #FFD200;
    }
  
    &:active {
      background: #FFD200;
    }
  
    &:focus-visible {
      box-shadow: 0 0 0 4px #FFD200 !important;
      outline: none;
    }
      
    `
);
